import fr from '../lang/fr.json';
import en from '../lang/en.json';

export const dictionaryList = { en, fr };

export const languageOptions = {
  en: 'English',
  fr: 'Français'
};
